var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.ScoreContainer = function() {
    EHDI.aka.Container.call(this);
};

EHDI.game.ScoreContainer.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.ScoreContainer.prototype.init = function () {
  this._textContainer;
  this._text1;
  this._animation;

  if (this._textContainer == null) {
    this._textContainer = new EHDI.aka.Container();

    this.addChild(this._textContainer);
  }

  if (this._text1 == null) {
    this._text1 = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_SCORE_ANIMATION"));

    this._text1.anchor.x = 0.5;
    this._text1.anchor.y = 0.5;

    this._textContainer.addChild(this._text1);
  }

  if (this._animation == null) {
    this._animation = new EHDI.game.Effect();
    this._animation.init('fx_pickup');

    // this._animation.getDisplay().x = -100;
    // this._animation.getDisplay().visible = false;
    this.addChild(this._animation.getDisplay());
  }

  this.visible = false;
}

EHDI.game.ScoreContainer.prototype.spawn = function (points) {
  this.visible = true;
  this._textContainer.y = 0;
  this._textContainer.alpha = 1;

  this._text1.text = "" + points;
  this._animation.changeAnimation(false);

  this._tl1 = TweenLite.to(this._textContainer, 1.5,{y:this._textContainer.y - 100, alpha:0, onComplete:this.animationComplete.bind(this)});
}

EHDI.game.ScoreContainer.prototype.animationComplete = function (points) {
  this.visible = false;
}
